import { defineStore } from 'pinia';
import { ref } from 'vue';

import { getUserCompanies } from '@/api/company/company.api';

import type { ICompany } from '@/types/company.type';

const useCompanyStore = defineStore('company', () => {
  // Refs
  const currentUserCompany = ref<ICompany | null>(null);
  const isCompanyLoading = ref<boolean>(false);
  const hasErrorCompany = ref<boolean>(false);

  // Functions
  const fetchUserCompanies = async (forceRefresh?: boolean) => {
    isCompanyLoading.value = true;
    hasErrorCompany.value = false;

    try {
      const response = await getUserCompanies(forceRefresh);
      currentUserCompany.value = response.length ? response[0] : null;
    } catch {
      hasErrorCompany.value = true;
    } finally {
      isCompanyLoading.value = false;
    }
  };

  return {
    // Refs
    currentUserCompany,
    isCompanyLoading,
    hasErrorCompany,
    // Functions
    fetchUserCompanies,
  };
});

export default useCompanyStore;
